<template>
  <div
    class="bg-FFFFFF"
    :class="headName ? 'pb-40' : 'p-40-0'"
    @click="clickHeader"
  >
    <div class="dorm-line-header" v-if="headName">
      <div class="p-14-0 c-171A1D font-34 fb fb-main-between fb-cross-center">
        <span class="ff-regular">{{ headName }}</span>
        <span class="iconfont c-171A1D-40">&#xe601;</span>
      </div>
    </div>
    <div class="fb fb-cross-center pl-6 pr-6" :class="{ 'pt-24': headName }">
      <div
        class="item-flex-1 fb fb-cross-center font-24 c-171A1D h-30 lh-30 text-center time-block"
        v-for="(item, index) in lineList"
        :key="index"
      >
        <div class="item-flex-1 relative">
          <div :class="`time-desc bd-radio-2 bg-back`">{{
            item.title || `时段${index + 1}`
          }}</div>
          <div
            v-show="item.endTime"
            class="absolute font-24 c-171A1D-40 w-32 text-center h-24 lh-16 text-center line-time-late"
            >{{ item.endTime }}
            <span
              class="absolute bl-767676 bd-radio-2 line-timeline-late"
            ></span>
          </div>
          <div
            v-show="item.startTime"
            class="absolute font-24 c-171A1D-40 w-32 text-center h-24 text-center line-time"
            >{{ item.startTime }}
            <span class="absolute bl-767676 line-timeline"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-006AFE line-bottom bd-radio-2"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    length: {
      type: [Number, String],
      default: 1
    },
    headName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      lineLength: this.length,
      lineList: this.list
    }
  },
  computed: {},
  watch: {
    length(l) {
      this.lineLength = l
    },
    list(v) {
      this.lineList = v
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    clickHeader() {
      this.$emit('headerClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-leave {
  background: rgba(255, 157, 22, 0.2);
}
.bg-back {
  background: rgba(0, 137, 255, 0.2);
}
.time-block {
  .time-desc {
    margin: 0 6px;
  }
  .line-time {
    bottom: -32px;
    left: -8px; // 32/2
  }
  .line-time-late {
    top: -24px;
    right: -8px; // 32-24 / 2
  }
}
.line-bottom {
  width: 100%;
  height: 4px;
  margin-top: 4px;
}

.line-timeline {
  top: 0;
  width: 2px;
  height: 7px;
  left: 50%;
  margin-left: -0.5px;
  border-radius: 1px;
}

.line-timeline-late {
  bottom: 0;
  width: 1px;
  height: 7px;
  left: 50%;
}
.bd-l-2 {
  border-radius: 2px 0 0 2px;
}
.bd-r-2 {
  border-radius: 0 2px 2px 0;
}
.bl-767676 {
  border-left: 1px solid #767676;
}
[data-dpr='2'] .bl-767676 {
  border-left: 2px solid #767676;
}
[data-dpr='3'] .bl-767676 {
  border-left: 3px solid #767676;
}
</style>
